import { fromJS, Map } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { ProviderInfo } from '@lyrahealth-inc/shared-app-logic'

import {
  CLEAR_DISPLAYED_PROVIDERS,
  GET_PROVIDER_RECOMMENDATIONS,
  HIDE_PROVIDER,
  REVEAL_NEXT_PROVIDER,
} from '../../data/onboardDataActions'

interface ProviderRecommendationsState extends Map<string, any> {
  totalNumberOfProviders?: number
  numberOfProvidersMatchingModalityPreference?: number
  numberOfNonTopProviders?: number
  providersDisplayed?: ProviderInfo[]
  hasSeenExpandedSearchModal?: boolean
  nextHiddenProviderIndex?: number
}

interface GetProviderRecommendationsAction {
  type: typeof GET_PROVIDER_RECOMMENDATIONS
  totalNumberOfProviders: number
  numberOfProvidersMatchingModalityPreference: number
  numberOfNonTopProviders: number
  providersDisplayed: ProviderInfo[]
  nextHiddenProviderIndex: number
}

export interface HideProviderAction {
  type: typeof HIDE_PROVIDER
  providersDisplayed: ProviderInfo[]
}

export interface RevealNextProviderAction {
  type: typeof REVEAL_NEXT_PROVIDER
  providersDisplayed: ProviderInfo[]
  nextHiddenProviderIndex: number
}

const initialState: ProviderRecommendationsState = fromJS({})

export default createReducer(initialState, {
  [GET_PROVIDER_RECOMMENDATIONS]: ($$state: ProviderRecommendationsState, action: GetProviderRecommendationsAction) => {
    $$state = $$state.set('totalNumberOfProviders', action.totalNumberOfProviders)
    $$state = $$state.set(
      'numberOfProvidersMatchingModalityPreference',
      action.numberOfProvidersMatchingModalityPreference,
    )
    $$state = $$state.set('numberOfNonTopProviders', action.numberOfNonTopProviders)
    $$state = $$state.set('providersDisplayed', action.providersDisplayed)
    $$state = $$state.set('hasSeenExpandedSearchModal', false) // reset expanded search modal visibility every time new recommendations are set
    $$state = $$state.set('nextHiddenProviderIndex', action.nextHiddenProviderIndex)
    return $$state
  },
  [HIDE_PROVIDER]: ($$state: ProviderRecommendationsState, action: HideProviderAction) => {
    $$state = $$state.set('providersDisplayed', action.providersDisplayed)
    return $$state
  },
  [REVEAL_NEXT_PROVIDER]: ($$state: ProviderRecommendationsState, action: RevealNextProviderAction) => {
    $$state = $$state.set('providersDisplayed', action.providersDisplayed)
    $$state = $$state.set('nextHiddenProviderIndex', action.nextHiddenProviderIndex)
    return $$state
  },
  [CLEAR_DISPLAYED_PROVIDERS]: ($$state: ProviderRecommendationsState) => {
    $$state = $$state.set('providersDisplayed', [])
    return $$state
  },
})
